import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {NgSelectModule} from '@ng-select/ng-select';
import {SharedModule} from '@shared/shared.module';
import {OrganizationComponent} from '@components/administration/organization/organization.component';
import {OrganizationEditComponent} from '@components/administration/organization/modal/organization-edit.component';
import {
  OrganizationActionComponent
} from '@components/administration/organization/organization-action/organization-action.component';
import {OrganizationRoutingModule} from '@components/administration/organization/organization-routing.module';
import {ConfigurationModule} from '@components/administration/organization/configuration/configuration.module';
import {
  OrganizationTableauConfigurationComponent
} from '@components/administration/organization/modal/organization-tableau-configuration/organization-tableau-configuration.component';


@NgModule({
  declarations: [
    OrganizationComponent,
    OrganizationEditComponent,
    OrganizationActionComponent,
    OrganizationTableauConfigurationComponent
  ],
  imports: [
    CommonModule,
    OrganizationRoutingModule,
    ConfigurationModule,
    TranslateModule,
    NgbModule,
    FormsModule,
    RouterModule,
    NgSelectModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  exports: [
    OrganizationComponent
  ]
})
export class OrganizationModule {
}
